
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        function changeVariantFormat(){
          $('.changeformat:not(.changeformat-done)').each(function() {
              $(this).addClass("changeformat-done"); 
            var text = $(this).text();
            var numberPattern = /\d+/g; // Regular expression to match all numbers
            var formattedText = text.replace(numberPattern, function(match) {
            var formattedNumber = parseInt(match).toLocaleString('en-US'); // Format the matched number
            return formattedNumber; // Return the formatted number to replace in the text
          });
          $(this).text(formattedText); // Update the text content of the element
        
        });
        }
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            var freeproductid = $('.freeProduct').attr("freevar_id");
            var checktf = $('.freeProduct');
            if (freeproductid != '' && checktf.hasClass("getfreeproduct")) {
              
            function updatecount(){
              fetch('/cart.json')
              .then(function(response) {
                return response.json();
              })
              .then(function(data) {
                var item_count = data.item_count;
                var cartcount = document.querySelectorAll('.cart-count-bubble > span');
                cartcount.forEach(function(cartcount) {
                  cartcount.textContent = item_count;
                });
              })
              .catch(function(error) {
                console.log('Error:', error);
              }); 
            }
            function updateCartItems() {
              $.ajax({
                url: location.href,
                dataType: 'html',
                success: function(data) {
                  let cartDrawerContent = $($.parseHTML(data)).filter("cart-drawer"); 
                  $('#CartDrawer').replaceWith(cartDrawerContent.html());
                  if(cartDrawerContent.hasClass("is-empty")){
                      $('cart-drawer').addClass("is-empty");
                  }else{
                     $('cart-drawer').removeClass("is-empty");
                  }
                   changeVariantFormat();
                },
                error: function(xhr, status, error) {
                  console.error('Error refreshing cart drawer:', error);
                }
              });
            }
            
            $.ajax({
              url: '/cart.js',
              type: "GET",
              dataType: 'json',
              success: function(cartData) {
                  const items = cartData.items;
          
                  // Check if the free product is already in the cart
                  const freeProductInCart = items.some(item => item.variant_id == freeproductid);
                  const freeProductQuantityOne = items.some(item => item.variant_id == freeproductid && item.quantity == 1);
          
                  // If the free product is not in the cart or its quantity is not one and a product with a variant title containing a number > 1000 is found, add the free product to the cart
                  const containsNumberOver1000 = items.some(item => {
                      const variantTitle = item.variant_title;
                      const numbers = variantTitle.match(/\d+/g); // Extract numbers from variant title
                      if (numbers) {
                          if (numbers.some(num => parseInt(num) > 1000) && (!freeProductInCart || !freeProductQuantityOne)) {
                              // Add the free product to the cart
                              $.ajax({
                                  url: '/cart/add.js',
                                  type: "POST",
                                  dataType: 'json',
                                  data: {
                                      id: freeproductid, // ID of the free product
                                      quantity: 1
                                  },
                                  beforeSend: function() {
                                      $('.drawer__inner').addClass("loading");
                                  },
                                  success: function(response) {
                                      updateCartItems();
                                      console.log('Free product added to cart successfully');  
                                      updatecount();
                                  },
                                  error: function(xhr, status, error) {
                                      console.error('Error adding free product to cart:', error);
                                  },
                                  complete: function() {
                                      setTimeout(function(){
                                          $('.drawer__inner').removeClass("loading"); 
                                      }, 1000);
                                    
                                  }
                              });
                              return true; // Stop iterating through items if a number > 1000 is found
                          }
                      }
                      return false;
                  });
          
                  if (!containsNumberOver1000) {
                      console.log('No item with number > 1000 found in cart');
                  }
              },
              error: function(xhr, status, error) {
                  console.error('Error fetching cart contents:', error);
                  // Display an error message to the user
                  //alert('Error fetching cart contents. Please try again later.');
              }
          });
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
